import { render } from "./InicioSC.vue?vue&type=template&id=6152da81&scoped=true"
import script from "./InicioSC.vue?vue&type=script&lang=js"
export * from "./InicioSC.vue?vue&type=script&lang=js"

import "./InicioSC.vue?vue&type=style&index=0&id=6152da81&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6152da81"]])

export default __exports__